const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000/api';
const UPLOAD_BASE_URL = process.env.REACT_APP_UPLOAD_URL || 'http://127.0.0.1:5000/uploads';

export { API_BASE_URL, UPLOAD_BASE_URL };
